module.exports = __webpack_public_path__ + "img/logo.7a2cce8b.png";